import { render, staticRenderFns } from "./RateDetailSubStorageIndex.vue?vue&type=template&id=2a30ceb3&scoped=true&"
import script from "./RateDetailSubStorageIndex.vue?vue&type=script&lang=js&"
export * from "./RateDetailSubStorageIndex.vue?vue&type=script&lang=js&"
import style0 from "./RateDetailSubStorageIndex.vue?vue&type=style&index=0&id=2a30ceb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a30ceb3",
  null
  
)

export default component.exports